import { getAPIHeaders } from 'src/services/apiRequests/Login/LoginService';
import { KEY_CODES } from 'src/utils/constants/AppConstants';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';

import { SuggestionType } from './SearchTypes';
import { httpService } from '../../services/fetch/HttpService';
import {
  getLocalStorage,
  getObjectFromLocalStorage,
  setLocalStorage
} from '../../utils/browserStorageHandler';
import { DynamicObject } from '../../utils/commonTypes';
import { SETTINGS_API_URL } from '../../utils/constants/ApiConstants';
import { USER_TOKEN } from '../../utils/constants/localStorageConstants';
import {
  NEW_RECENT_MAX_SEARCH_LENGTH,
  RECENT_MAX_SEARCH_LENGTH,
  SETTINGS
} from '../../utils/constants/stringConstants';

const saveSettings = async (recentSearchString: string) => {
  const settingsObj: DynamicObject = {};
  settingsObj.key = 'recent_search';
  settingsObj.value = recentSearchString;
  const headers = getAPIHeaders();
  const settings = JSON.parse(getLocalStorage(SETTINGS));
  if (Object.keys(settings).includes('recent_search')) {
    httpService.fetchApiData({
      url: SETTINGS_API_URL,
      type: HTTP_METHODS.PUT,
      body: settingsObj,
      headers
    });
  } else {
    httpService.fetchApiData({
      url: SETTINGS_API_URL,
      type: HTTP_METHODS.POST,
      body: settingsObj,
      headers
    });
  }
};

export const getHighlightedText = (
  queryString: string,
  suggestedText: string
) => {
  const index = suggestedText.indexOf(queryString.toLowerCase());
  let formattedText = '';
  if (index > -1) {
    formattedText += `<span>${suggestedText.substring(0, index)}`;
    formattedText += `<span style='color:#a785ff'>${suggestedText.substring(
      index,
      index + queryString.length
    )}</span>`;
    formattedText += `${suggestedText.substring(
      index + queryString.length
    )}</span>`;
  } else {
    formattedText = suggestedText;
  }
  return formattedText;
};

export const saveRecentSearchLocalStorage = (
  queryString: string,
  recentSearchData: Array<string>,
  isNewSearchRevamp = false
) => {
  let recentSearchString = '';
  let settings = getLocalStorage(SETTINGS);
  if (recentSearchData) {
    const index = recentSearchData.findIndex(
      (row: string) => row.toLowerCase() === queryString.toLowerCase()
    );
    const countOfRecentSearch = isNewSearchRevamp
      ? NEW_RECENT_MAX_SEARCH_LENGTH
      : RECENT_MAX_SEARCH_LENGTH;
    recentSearchData = recentSearchData?.splice(0, countOfRecentSearch);
    if (index >= 0) {
      recentSearchData.splice(index, 1);
      recentSearchData.unshift(queryString);
      const appendSearchStr = recentSearchData.join(',');
      recentSearchString = appendSearchStr;
    } else {
      if (recentSearchData?.length === countOfRecentSearch) {
        recentSearchData.pop();
      }
      recentSearchData.unshift(queryString);
      recentSearchString = recentSearchData.join(',');
    }
  } else {
    recentSearchString = queryString;
  }
  settings = {
    ...getObjectFromLocalStorage(SETTINGS),
    recent_search: recentSearchString
  };
  setLocalStorage(SETTINGS, settings);
  if (!getLocalStorage(USER_TOKEN)) {
    return recentSearchString;
  } else {
    saveSettings(recentSearchString);
    return recentSearchString;
  }
};

export const clearRecentSearchData = (
  currentSearch: string,
  isUserLoggedIn: boolean
) => {
  /* Removing individual search items from local storage */
  let settings = getLocalStorage(SETTINGS);
  let searchItem: Array<string>;
  let filteredSearchItem = isUserLoggedIn ? '-' : '';
  if (currentSearch) {
    const getRecentSearch = JSON.parse(settings).recent_search;
    const splitRecentSearch = getRecentSearch.split(',');
    if (splitRecentSearch.length > 1) {
      searchItem = splitRecentSearch.filter(
        (item: string) => item !== currentSearch
      );
      filteredSearchItem = searchItem.join(',');
    }
  }
  settings = {
    ...getObjectFromLocalStorage(SETTINGS),
    recent_search: filteredSearchItem
  };
  setLocalStorage(SETTINGS, settings);
  if (!isUserLoggedIn) {
    return filteredSearchItem;
  } else {
    saveSettings(filteredSearchItem);
    return filteredSearchItem;
  }
};

export const clearAllRecentSearch = () => {
  const settings = {
    ...getObjectFromLocalStorage(SETTINGS),
    recent_search: ''
  };
  setLocalStorage(SETTINGS, settings);
  if (getLocalStorage(USER_TOKEN)) {
    saveSettings('-');
  }
};

export const filterWhiteSpaceAndHyphen = (data: string) => {
  return (
    data.split(',').filter((val: string) => {
      return val !== '' && val !== '-';
    }) || []
  );
};

export const getCurrentIndex = (
  event: React.KeyboardEvent<HTMLInputElement>,
  suggestionResult: SuggestionType[],
  currentIndex: number,
  setCurrentIndex: (currentIndex: number) => void
) => {
  const input = event.key;
  const suggestionResultLength = suggestionResult?.length;
  let newIndex = currentIndex;
  if (newIndex === -1 && input === KEY_CODES.ARROW_UP) {
    newIndex = 0;
  }
  if (input === KEY_CODES.ARROW_UP) {
    newIndex =
      (suggestionResultLength + ((newIndex - 1) % suggestionResultLength)) %
      suggestionResultLength;
  } else if (input === KEY_CODES.ARROW_DOWN) {
    newIndex = (newIndex + 1) % suggestionResultLength;
  }
  setCurrentIndex(newIndex);
};
